// extracted by mini-css-extract-plugin
export default {"help-section":"styles_help-section__mXzXq","help-section-container":"styles_help-section-container__oVoFS"};